import {
    ColumnConfig,
    FeatureConfig, FooterConfig, FooterOptions, WorkspacePreset,
} from '../store/workspaces/types';

const workspaceParser = {
    parseLayout: (layout: number[]): number[] => {
        return layout;
    },

    parseFooterFeatureOptions: (footer: any): FooterOptions => {
        return footer.options;
    },

    getFeatureConfig: (main: ColumnConfig[], type: string): FeatureConfig => {
        let feature: any = null;
        // eslint-disable-next-line no-restricted-syntax
        for (const column of main) {
            feature = column.features.find((currentFeature: FeatureConfig) => currentFeature.type === type);
            if (feature) {
                break;
            }
        }
        return feature;
    },

    isShowFooter: (footer: FooterConfig): boolean => {
        return !!footer?.showFooter;
    },

    getFeaturesCount: (workspace: WorkspacePreset): number => {
        let count = 0;

        workspace.main.forEach((column: ColumnConfig) => {
            column.features.forEach(() => {
                count += 1;
            });
        });

        if (workspace.footer && workspace.footer.showFooter) {
            count += 1;
        }

        if (workspace.workspaceHeader && workspace.workspaceHeader.showHeader) {
            count += 1;
        }

        return count;
    },
};

export default workspaceParser;
